// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".iconButton{display:flex;flex-direction:row;align-items:flex-start;padding:12px;gap:10px;width:48px;height:48px;background:#fff;border:1px solid #d8d5dd;border-radius:12px}.iconButton:hover{box-shadow:0px 4px 12px -2px rgba(164,156,176,.4)}.iconButton:hover svg path{fill:#fe3c72}", ""]);
// Exports
module.exports = exports;
